import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGaurdService } from '../service/auth-gaurd.service';
import { ManageRegionsComponent } from './manage-regions/manage-regions.component';

const routes: Routes = [
  {path:'manage-regions', component:ManageRegionsComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegionsRoutingModule { }
